export const vairAggregatesDummyData = {
  aiAnsweredCalls: 0,
  aiEngagedCalls: 0,
  appointmentsScheduled: 52,
  appointmentsSchedulingAction: 52,
  appointmentsReschedulingAction: 5,
  unscheduledSchedulingOpportunities: 0,
  recoveredSchedulingOpportunities: 0,
  aiThreads: 793,
  aiInteractedThreads: 421,
  pendingThreads: 0,
  totalAiConversations: 793,
  userRespondedConversations: 421,
  appointmentScheduled: 52,
  appointmentRescheduled: 5,
  schedulingLeads: 52,
  scheduledByOthers: 0,
  afterHoursAiConversations: 0,
  afterHoursAppointmentsScheduled: 0,
  totalTasks: 262,
  schedulingTasks: 95,
  nonSchedulingTasks: 167,
  lastPeriod: {
    afterHoursAiConversations: 0,
    afterHoursAppointmentsScheduled: 0,
  },
  pendingTasksCount: 251,
  unscheduledOpportunities: 0,
};
